export default "<p>size-detector works!</p>\n"